<template>
  <div>
    <app-cells><h1 class="title">Fund requests</h1></app-cells>
    <app-tabs :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'FinanceFundRequests',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'finance-fund-requests-active', label: 'Active'},
        { name: 'finance-fund-requests-completed', label: 'Completed'},
        { name: 'finance-fund-requests-rejected', label: 'Rejected'},
      ],
    }
  },
}
</script>
